export default "__VITE_ASSET__DZrNyCLp__"